<template>
  <!-- ふきだし -->
  <v-container class="pa-0">
    <div class="line-bc">
      <div class="mycomment" v-if="question">
        <p class="pre-wrap" v-text="question" />
      </div>
      <div class="balloon6">
        <div class="faceicon">
          <img :src="iconUrl" />
        </div>
        <div class="chatting">
          <div :class="styleContent">
            <span class="pre-wrap" v-text="content" />
          </div>
        </div>
      </div>
    </div>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: {
    question: String,
    content: String,
    borderContent: { type: Boolean, default: true },
  },

  data: () => ({
    // ふきだし(左側)
    styleContent: "",
  }),
  created() {
    this.styleContent = this.borderContent ? "says-border" : "says";
  },
  async mounted() {},
  computed: {
    ...mapGetters(["iconUrl"]),
  },
  methods: {},
};
</script>

<style>
@import "../../css/common.css";
@import "../../css/bubble.css";
</style>
